import { render, staticRenderFns } from "./ClasseIbpModal.vue?vue&type=template&id=c355b0ca&scoped=true"
import script from "./ClasseIbpModal.vue?vue&type=script&lang=js"
export * from "./ClasseIbpModal.vue?vue&type=script&lang=js"
import style0 from "./ClasseIbpModal.vue?vue&type=style&index=0&id=c355b0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c355b0ca",
  null
  
)

export default component.exports